import {
  FaTruck,
  FaRecycle,
  FaCheckCircle,
  FaClock,
  FaShieldAlt,
  FaLeaf,
} from "react-icons/fa";
import { FiPhone } from "react-icons/fi";
import { useTranslation } from "react-i18next";

import Servicesdiv from "../components/Services";
import banner from "../assets/about-banner.jpg";
import ctaImage from "../assets/image3.jpg";

const Services = () => {
  const { t } = useTranslation();

  const workSteps = [
    {
      icon: <FaClock />,
      title: t("workStep1Title"),
      text: t("workStep1Text"),
    },
    {
      icon: <FaTruck />,
      title: t("workStep2Title"),
      text: t("workStep2Text"),
    },
    {
      icon: <FaShieldAlt />,
      title: t("workStep3Title"),
      text: t("workStep3Text"),
    },
    {
      icon: <FaRecycle />,
      title: t("workStep4Title"),
      text: t("workStep4Text"),
    },
  ];

  const benefits = [
    t("benefit1"),
    t("benefit2"),
    t("benefit3"),
    t("benefit4"),
    t("benefit5"),
    t("benefit6"),
    t("benefit7"),
    t("benefit8"),
  ];

  return (
    <div className="bg-light text-dark overflow-hidden">
      <div className="py-16 md:py-24 xl:py-32">
        <div className="container mx-auto px-5 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-20">
          <div className="text-center mb-14">
            <span className="text-green font-semibold uppercase tracking-[3px]">
              {t("services2")}
            </span>

            <h2 className="text-3xl text-dark md:text-5xl font-bold mt-4">
              {t("howWeWork")}
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-5 lg:gap-7">
            {workSteps.map((step, index) => (
              <div key={index} className="bg-gray-50 rounded-3xl p-8">
                <div className="text-4xl text-green mb-6">{step.icon}</div>

                <h3 className="text-2xl font-semibold text-dark mb-4">
                  {step.title}
                </h3>

                <p className="text-dark/70 leading-relaxed">{step.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <Servicesdiv />

      <div className="py-16 md:py-24 xl:py-32">
        <div className="container mx-auto px-5 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-20">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 xl:gap-20 items-center">
            <div>
              <span className="text-green font-semibold uppercase tracking-[3px]">
                {t("ourBenefits")}
              </span>

              <h2 className="text-3xl text-dark md:text-5xl font-bold mt-4 mb-10 leading-tight">
                {t("whyChooseUs")}
              </h2>

              <div className="space-y-5">
                {benefits.map((item, index) => (
                  <div
                    key={index}
                    className="flex items-start gap-4 bg-gray-50 p-5 rounded-2xl"
                  >
                    <div className="text-green text-xl mt-1">
                      <FaCheckCircle />
                    </div>

                    <p className="text-gray-700 text-lg leading-relaxed">
                      {item}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            <div className="relative">
              <img
                src={banner}
                alt="Truck"
                className="w-full h-[320px] sm:h-[420px] md:h-[520px] xl:h-[650px] object-cover md:rounded-3xl shadow-2xl"
              />

              <div className="md:absolute -bottom-8 -left-8 bg-white md:rounded-3xl shadow-xl p-8 md:max-w-xs">
                <div className="flex items-center gap-4 mb-4">
                  <div className="bg-green-100 text-green p-4 rounded-2xl text-2xl">
                    <FaLeaf />
                  </div>

                  <div>
                    <p className="text-gray-500 text-xs">
                      {t("responsibleManagement")}
                    </p>

                    <h4 className="font-bold text-xl text-greenDark">
                      {t("ecoApproach")}
                    </h4>
                  </div>
                </div>

                <p className="text-gray-600 leading-relaxed">
                  {t("ecoDescription")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="relative w-full overflow-hidden">
        <img
          className="w-full h-350 lg:h-400 object-cover"
          src={ctaImage}
          alt="hero"
        />

        <div className="container mx-auto px-6 md:px-20">
          <div className="absolute inset-0 bg-black/70"></div>

          <div className="absolute inset-0 flex flex-col justify-center items-center px-6 md:px-12 text-light">
            <h1 className="text-3xl text-light md:text-5xl font-bold mb-8 text-center">
              {t("contactToday")}
            </h1>

            <p className="max-w-670 font-light text-center text-sm md:text-base xl:text-xl mb-6 leading-relaxed">
              {t("ctaText")}
            </p>

            <a
              href="tel:+995599000000"
              className="flex justify-center items-center gap-2 w-fit text-light px-6 py-3 rounded-full bg-green transition-all duration-300 hover:bg-greenDark"
            >
              <FiPhone />
              {t("call")}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
